var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5303 2.46967C21.8232 2.76256 21.8232 3.23744 21.5303 3.53033L4.53033 20.5303C4.23744 20.8232 3.76256 20.8232 3.46967 20.5303C3.17678 20.2374 3.17678 19.7626 3.46967 19.4697L20.4697 2.46967C20.7626 2.17678 21.2374 2.17678 21.5303 2.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2673 13.9147C14.1156 14.1402 14.8735 14.5869 15.4767 15.1901C15.7696 15.483 16.2444 15.483 16.5373 15.1901C16.8302 14.8972 16.8302 14.4223 16.5373 14.1294C15.9447 13.5367 15.2359 13.0592 14.4482 12.7338L13.2673 13.9147Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6888 10.4932C17.4201 10.9119 18.0901 11.4257 18.6822 12.0178C18.9751 12.3107 19.45 12.3107 19.7429 12.0178C20.0358 11.7249 20.0358 11.2501 19.7429 10.9572C19.1525 10.3668 18.4948 9.8435 17.7824 9.39966L16.6888 10.4932Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9523 7.22972C20.2911 7.46441 20.6191 7.7137 20.9353 7.97667C21.266 8.25171 21.5838 8.54171 21.8878 8.84564C22.1807 9.13854 22.6555 9.13854 22.9484 8.84564C23.2413 8.55275 23.2413 8.07788 22.9484 7.78498C22.6121 7.44867 22.2604 7.12775 21.8944 6.82337C21.614 6.59018 21.3252 6.3667 21.0286 6.15344L19.9523 7.22972Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8071 4.01091L15.6003 5.21768C14.4518 4.91257 13.245 4.75 12.0001 4.75C8.13847 4.75 4.64367 6.31432 2.11236 8.84562C1.81947 9.13852 1.34459 9.13852 1.0517 8.84562C0.758808 8.55273 0.758808 8.07786 1.0517 7.78496C3.85281 4.98385 7.72467 3.25 12.0001 3.25C13.6779 3.25 15.2937 3.51706 16.8071 4.01091Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.021 7.797C12.6849 7.7659 12.3443 7.75 12.0001 7.75C8.97654 7.75 6.23801 8.97644 4.25727 10.9572C3.96438 11.2501 3.96438 11.7249 4.25727 12.0178C4.55016 12.3107 5.02504 12.3107 5.31793 12.0178C6.93169 10.4041 9.12418 9.37217 11.5579 9.26015L13.021 7.797Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSlash);
export default __webpack_public_path__ + "static/media/wifi-slash.325604b97296e1d9a5ff06b234fe41a9.svg";
export { ForwardRef as ReactComponent };